<template lang="html">

    <section class="wrapper wrapper-view">
  
        <header class="encabezado row-center encabezado-home">
  
        <router-link class="logo row-start" to="/">
          <img :src="logoselected" alt="Logo" :size="logosize">
        </router-link>
  
        <h1 class="bottom header-ss">Datos Seguridad Social</h1>
  
      </header>
  
      <div class="divisor-ss"> 
      </div>
  
      <div class="subtitulo-ss"> 
        <h1 class="title" style="font-size: 1.25em;">Recuerda que para poder realizar tus prácticas será necesario que nos proporciones tu Número de la Seguridad Social.</h1>
      </div>
  
      <div class="subtitulo-ss-white"> 
        <h1 class="title" style="font-size: 1.5em;">¿Cómo obtenerlo?</h1>
        <h1 class="title" style="font-size: 1em;padding-top:20px;padding-bottom:0px;"><i>Para solicitar tu Número de Seguridad Social podrás realizarlo:</i></h1>
      </div>
  
      <div class="text-ss"> 
        <label class="text-ss-title">Si tienes Certificado electrónico/DNIe</label>
        <div style=height:8px;></div><hr><div style=height:8px;></div>
        <label class="text-ss-text">A través del servicio <a target="_blank" href="https://sede.seg-social.gob.es/wps/portal/sede/sede/Ciudadanos/CiudadanoDetalle/!ut/p/z1/rVRNb-IwFPwr7YGj5eePOM4xVCglS4ooTUtyQV7boa4goZBld_vr66BKPVSEStQ-WH4ej_3mjY1LvMBlrQ5upVrX1Grt50UplowITiIgkwTGI4jz7FcesRlLxgQ_HQFwosWAy-_sPwGA6Oz-R1ziUtfttn3Gxd4au9RN3dramWY_gC4wAO3-GGVU3UVU5dZOaZ_dlb1y9V7v3LabDYD6LmVH5wMGF9IYbYjliMuAIq5YgKS1ApFKRTZknAda-OuXfTc8JnAE9CnUz0D6AQkV-BZw2kuSBrjwQoefAIDEH54PYf4IlEDC8NPB2b84r5vdxhd-_inEb019HtYiEMYLoSFECmSFIkW5IEJTEn6hT8gs6Oincnw_IyDDH6EPphJICnQCIpMQR7N5PrkjDEJ-IX16TmH_Duguu8lWnla1z8jVVYMXp8yEFxCeXsOFe3l9LWPv286q_1q8uMi4PWd9qcqQQ0ymD4LejghMe2T7lvt7q5IAuZA-Pff4f1zKjz9gu8nzjWTiflTdZCMWrDbLbli__GdvwztUpIe3SRxfX78DGqMzKw!!/dz/d5/L2dBISEvZ0FBIS9nQSEh/">Solicitar Número de Seguridad Social</a> existente en la Sede Electrónica de la Seguridad Social y Portal de la TGSS -Importass-. El acceso a dicho servicio se puede hacer por SMS, Clave PIN, Cl@ve Permanente y Certificado electrónico/DNIe. Los datos necesarios son los datos identificativos (DNI o NIE), datos de contacto (teléfono móvil y email) y domicilio habitual.</label>
      </div>
  
      <div class="text-ss"> 
        <label class="text-ss-title">Si no tienes Certificado electrónico/DNIe</label>
        <div style=height:8px;></div><hr><div style=height:8px;></div>
        <label class="text-ss-text">A través del servicio Enviar una solicitud existente en el Portal de la TGSS -Importass- [Debe seleccionarse la categoría Ciudadano/Trabajador y seleccionar el trámite Obtención del Número de Afiliación]. Es obligatorio aportar el documento de identidad (DNI, NIE o pasaporte), dirección de correo electrónico y <a target="_blank" href="https://www.seg-social.es/wps/portal/wss/internet/Trabajadores/Afiliacion/10817/31190/572">modelo TA.1</a>, y contar con un dispositivo con cámara para hacerse una fotografía (ordenador, móvil...). Se puede enviar sin necesidad de firmar.</label>
      </div>
  
      <div class="text-ss"> 
        <label class="text-ss-title">Presencialmente</label>
        <div style=height:8px;></div><hr><div style=height:8px;></div>
        <label class="text-ss-text">También podrás solicitarlo presencialmente en la <a target="_blank" href="https://www.seg-social.es/wps/portal/wss/internet/OficinaSeguridadSocial/">Administración de la Tesorería General de la Seguridad Social</a> de tu provincia.</label>
      </div>
  
      <form @submit.prevent="validateBeforeSubmit">
  
        <div class="long-form">
          <div class="contenedor-input row-start"> 
            <h1 class="title">Mis datos</h1>
          </div>  
          
          <div class="text-container row-start">
  
            <div class="contenedor-input type-text mid-slot">
                <label for="dni">Introduce tu DNI* </label>
                <popup-info :texto="'dni_seg_social'" :side="'right'" style="left: 140px;"></popup-info> 
                <input type="text" v-validate="'required'" name="dni" v-model="data.dni">
                <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('dni') }}</span>
            </div>
            
            <div class="contenedor-input type-text mid-slot">
                <label for="">Introduce tu NSS*</label>
                <input type="text" v-validate="'required'" name="numSeguridadSocial" v-model="data.numSeguridadSocial">
                <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('numSeguridadSocial') }}</span>
            </div>
  
            <div class="contenedor-input one-slot">
                <label for="">Introduce la acreditación generada*</label>
                <popup-info :texto="'acreditacion_seg_social'" :side="'right'" style="left: 290px;"></popup-info> 
                 
                  <div class="documentos">
                    <article class="documentacion-el espaciar" v-if="data.adjunto.id != ''">
                        <button class="erase" :style="style.colorBasic" @click="eraseAdjunto()" style="top:4px">X</button>
                        <strong target="_blank" :style="style.colorBasic">{{(!!data.adjunto.nombre) ?
                            data.adjunto.nombre : 'Fichero adjunto '+(data.adjunto.nombre)}}</strong>
                    </article>
                  </div>
                  <a class="row-start add-link espaciar" :style="style.colorBasic" @click="showdropzone = true" v-if="!showdropzone">
                  <add-icon></add-icon>{{$t('cv.anadir_documento')}}
                  </a>
            </div>
            <div class="contenedor-input two-slot"></div>
            <div class="contenedor-input one-slot">
              <dropzone v-if="showdropzone" @emit="setDoc" ref="dropzone"></dropzone>
            </div>
          <div class="contenedor-input" :error="errors.has('politica')">
            <input type="checkbox" id="politica" name="politica" v-validate="'required'" v-model="data.politica">
            <label for="politica">He leído y acepto la <a href="politica-privacidad-seguridad-social" target="_blank">Política de privacidad*</a></label>
              <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('politica') }}</span>
          </div>
  
            <button class="btn -solid-primary" :loading="loading">Enviar</button>
            
          </div>
        </div>
  
      </form>
  
    </section>
  
  </template>
  
  <script lang="js">
  
    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
  
    Vue.use(VeeValidate);
  
    import { mapGetters, mapActions } from 'vuex'
  
    import formulario from '@/components/views/contacto/formulario'
    import dropzone from '@/components/parts/form/dropzone';
    import addIcon from '@/components/parts/icons/add'
    import popupInfo from '@/components/parts/popup-info';
  
    export default {
      name: 'datos-seguridad-social',
      components: {
        'dropzone': dropzone,
        'popup-info': popupInfo,
        'add-icon': addIcon,
      },
      computed:{
        ...mapGetters({
        logo: 'getLogo',
        logocolor: 'getLogoColor',
        logoencabezado: 'getLogoEncabezado',
        logosize: 'getLogoSize',
        style: 'getStyles',
        }),
        logoselected() {
            let logo = (!!this.logoencabezado) ? this.logoencabezado : this.logo;

            if (this.darkmode) {
                logo = this.brand.logodarkmode;
            }

            return logo;
        }
      },
      data(){
        return{
          loading: false,
          clicked : false,
          showDni: false,
          showSS: false,
          showdropzone: false,
          data : {
            dni:"",
            numSeguridadSocial:"",
            politica: "",
            adjunto: {
              "id": "",
              "fecha": "",
              "tipo": "1",
              "enlace": "",
              "nombre": "",
              "ficheroB64ParaAltas": "",
              "extension_adjunto": "",
              "idDocumentoNecesarioOfertaNoTipado": 0
            }
          }
        }
      },
      methods: {
        ...mapActions(['addDoc2']),
        validateBeforeSubmit: function () {
          this.clicked = true;
          this.$validator.validateAll().then(canSend => {
            if (canSend) {
              this.loading = true;
              this.addDoc2(this.data).then(result => {
                this.loading = false;
                if (result){
                  this.data = { dni:"", numSeguridadSocial:"", politica: "", adjunto: { "id": "", "fecha": "", "tipo": "1", "enlace": "", "nombre": "", "ficheroB64ParaAltas": "", "extension_adjunto": "", "idDocumentoNecesarioOfertaNoTipado": 0 }};
                  this.clicked = false;
                  this.showdropzone = false;
                  scroll(0,0);
                }
              });
            }
          });
        },
        eraseAdjunto(){
          this.data.adjunto = {
              "id": "",
              "fecha": "",
              "tipo": "1",
              "enlace": "",
              "nombre": "",
              "ficheroB64ParaAltas": "",
              "extension_adjunto": "",
              "idDocumentoNecesarioOfertaNoTipado": 0
            };
        },
        setDoc(value) {
            this.data.adjunto = value;
            this.$refs.dropzone.reset();
            this.showdropzone = false;
        },
      },
    }
  </script>
  
  <style scoped lang="scss">
    .mid-slot{
      width: calc(49% - 10px);
      margin-right: 15px;
    }
    h1{
      color: #003865;
    }
    a{
      color: #72A3DC;
    }
    a:hover{
      text-decoration: underline;
    }
    .wrapper-view {padding: 0 !important;}
    .espaciar {padding-top: 10px; padding-bottom: 5px;}
    .header-ss{    
      font-size: 2.5em;
      text-transform: uppercase;
      font-weight: 900;
      width: 100%;
      padding-bottom: 40px;
    }
  
    .divisor-ss{
      background: #003865;
      width: 100%;
      height: 40px;
    }
  
    .subtitulo-ss{
      background: rgb(0 56 101 / 20%);
      width: 100%;
      min-height: 130px;
      padding: 50px 200px;
      font-weight: 900;
      color: #003865;
    }
  
    .subtitulo-ss-white{
      width: 100%;
      min-height: 130px;
      padding: 50px 200px;
      font-weight: 900;
      color: #003865;
    }
  
    @media screen and (max-width: 750px) {
      .subtitulo-ss{
        background: rgb(0 56 101 / 20%);
        width: 100%;
        min-height: 130px;
        padding: 50px 20px;
        font-weight: 900;
        color: #003865;
      }
  
      .subtitulo-ss-white{
        width: 100%;
        min-height: 130px;
        padding: 50px 20px;
        font-weight: 900;
        color: #003865;
      }  
      
      .header-ss{    
        font-size: 1.5em;
      }
    }
  
    @media screen and (max-width: 375px) {
      .header-ss{    
        font-size: 1em;
      }
    }
  
    .text-ss{
      padding: 25px 350px;
      text-align: left;
      color: #4A4A4A;
    }
  
    .long-form{
      margin: 25px 350px 60px 350px;
      background: #F2F2F2;
      padding: 50px;
      width: auto !important;
    }
  
    @media screen and (max-width: 1750px) {
      .text-ss{
      padding: 25px 250px;
      }
      .long-form{
      margin: 50px 250px 60px 250px;
      }
    }
  
    @media screen and (max-width: 1500px) {
      .text-ss{
      padding: 25px 200px;
      }
      .long-form{
      margin: 50px 200px 60px 200px;
      }
    }
  
    @media screen and (max-width: 850px) {
      .text-ss{
      padding: 25px 75px;
      }
      .long-form{
      margin: 50px 75px 60px 75px;
      }
    }
  
    @media screen and (max-width: 650px) {
      .text-ss{
      padding: 25px 20px;
      }
      .long-form{
      margin: 50px 20px 60px 20px;
      }
    }
  
  
    @media screen and (max-width: 500px) {
      .long-form{
      padding: 20px;
      }
    }
  
    .text-ss-title{
      font-size: 1.3em;
      min-width: 100%;
      font-weight: 900
    }
  
    .text-ss-text{
      font-size: 1em;
      width: 100%;
    }
  
    .form-ss{
      margin: 70px;
      background: #F2F2F2;
      height: 500px;
    }
  </style>


// WEBPACK FOOTER //
// src/components/views/datos-seguridad-social.vue